import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaInstagram, FaYoutube, FaArrowUp, FaTiktok, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import './styles.css';
import logo from '../assets/logo.svg';
import VisitorCounter from './VisitorCounter';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [time, setTime] = useState(new Date());
  const [socialLinks, setSocialLinks] = useState({
    instagram: 'https://www.instagram.com/official_smkparsmb/',
    tiktok: 'https://www.tiktok.com/@pariwisatasumbangsih',
    youtube: 'https://www.youtube.com/c/SMKPARIWISATASUMBANGSIH'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const docRef = doc(db, "settings", "siteConfig");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setSocialLinks(prev => ({ ...prev, instagram: data.instagramUrl || prev.instagram }));
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Menampilkan atau menyembunyikan tombol berdasarkan posisi scroll
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    const duration = 1200; // Durasi dalam milidetik (1.2 detik), bisa disesuaikan agar lebih "perlahan"
    const start = window.scrollY;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    // Fungsi easing untuk animasi yang lebih halus (mulai pelan, cepat di tengah, pelan di akhir)
    const easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const scroll = () => {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, ((now - startTime) / duration));
      const timeFunction = easeInOutCubic(time);

      window.scrollTo(0, Math.ceil(start + ((0 - start) * timeFunction)));

      // Hentikan animasi jika sudah sampai atas atau pengguna scroll manual
      if (window.scrollY === 0 || window.scrollY > start) {
        return;
      }
      requestAnimationFrame(scroll);
    };
    requestAnimationFrame(scroll);
  };

  return (
    <footer className="modern-footer">
      <div className="container">
        <div className="footer-top-section">
          <div className="footer-col footer-about">
            <h3 className="footer-section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src={logo} alt="Logo SMK" className="footer-logo-img" />
              SMK Pariwisata Sumbangsih
            </h3>
            <p style={{ textAlign: 'justify' }}>
              Lembaga pendidikan kejuruan yang berdedikasi untuk mencetak tenaga
              kerja profesional dan berkarakter di bidang pariwisata.
            </p>
            <div className="social-icons">
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <div className="footer-col footer-links">
            <h3 className="footer-section-title">Navigasi</h3>
            <ul>
              <li><Link to="/" className="footer-link-item">Beranda</Link></li>
              <li><Link to="/tentang-kami" className="footer-link-item">Tentang Kami</Link></li>
              <li><Link to="/jurusan" className="footer-link-item">Program Keahlian</Link></li>
              <li><Link to="/galeri" className="footer-link-item">Galeri</Link></li>
              <li><Link to="/berita" className="footer-link-item">Berita</Link></li>
              <li><Link to="/spmb" className="footer-link-item">SPMB Online</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-contact">
            <h3 className="footer-section-title">Hubungi Kami</h3>
            <p className="footer-contact-item">
              <FaMapMarkerAlt />
              <a href="https://maps.google.com/?q=SMK+Pariwisata+Sumbangsih" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                Jl. Muwardi II No.13, RT.8/RW.2, Grogol, Kec. Grogol petamburan, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11450
              </a>
            </p>
            <p className="footer-contact-item">
              <FaEnvelope />
              <a href="mailto:sumbangsihsmk@gmail.com" className="footer-contact-link">Email: sumbangsihsmk@gmail.com</a>
            </p>
            <p className="footer-contact-item">
              <FaPhone />
              <a href="tel:02122562271" className="footer-contact-link">No Telepon: (021) 22562271</a>
            </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-info-stack">
          <p className="copyright-text">&copy; 2025 SMK Pariwisata Sumbangsih. All Rights Reserved.</p>
          <div className="footer-datetime">
            {time.toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
            {' | '}

            {time.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })} WIB
          </div>
          <div style={{ marginLeft: '0px', display: 'inline-block' }}>
            <VisitorCounter />
          </div>
        </div>
        <button onClick={scrollToTop} className={`back-to-top ${isVisible ? 'show' : ''}`} aria-label="Back to top">
          <FaArrowUp />
        </button>
      </div>
    </footer>
  );
};

export default Footer;